module.exports = __webpack_public_path__ + "img/valueAdded.45223068.jpg";